import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { useUserRoles } from '../hooks/useUserRoles';
import AdminTalentsList from '../pages/Administration/AdminTalents/AdminTalentsList';
import CreateTalent from '../pages/Administration/AdminTalents/CreateTalent/CreateTalent';
import CompaniesList from '../pages/Administration/Companies/CompaniesList';
import CreateCompany from '../pages/Administration/Companies/CreateCompany/CreateCompany';
import ManagerDetails from '../pages/Administration/Managers/ManagerDetails/ManagerDetails';
import ManagersList from '../pages/Administration/Managers/ManagersList';
import CreateManager from '../pages/Administration/AdminManagers/CreateManager/CreateManager';
import BulkUpload from '../pages/BulkUpload/BulkUpload';
import CreatePayment from '../pages/CreatePayment/CreatePayment';
import CreateProject from '../pages/CreateProject/CreateProject';
import Dashboard from '../pages/Dashboard/Dashboard';
import InvoiceDetails from '../pages/Invoices/InvoiceDetails/InvoiceDetails';
import InvoicesList from '../pages/Invoices/InvoicesList';
import Profile from '../pages/Profile/Profile';
import ProjectDetails from '../pages/Projects/ProjectDetails/ProjectDetails';
import ProjectsList from '../pages/Projects/ProjectsList';
import TalentDetails from '../pages/Talents/TalentDetails/TalentDetails';
import TalentsList from '../pages/Talents/TalentsList';
import ReportList from '../pages/Reporting/ReportsList';

import {
  ADMINISTRATION_COMPANIES,
  ADMINISTRATION_COMPANIES_CREATE,
  ADMINISTRATION_COMPANIES_EDIT,
  ADMINISTRATION_MANAGERS,
  ADMINISTRATION_MANAGERS_CREATE,
  ADMINISTRATION_MANAGERS_EDIT,
  ADMINISTRATION_TALENT,
  ADMINISTRATION_TALENT_CREATE,
  ADMINISTRATION_TALENT_EDIT,
  BULK_UPLOAD,
  CREATE_PAYMENT,
  CREATE_PROJECT,
  DASHBOARD,
  EDIT_PROJECT,
  INVOICES,
  PROFILE,
  PROJECTS,
  REPORTING,
  TALENT
} from './constants';

const RouterConfig = (): JSX.Element => {
  const { isAdmin, isCompanyManager } = useUserRoles();
  return (
    <Routes>
      <Route path={DASHBOARD} element={<Dashboard />} />
      <Route path={PROJECTS} element={<ProjectsList />} />
      <Route path={`${PROJECTS}/:id`} element={<ProjectDetails />} />
      <Route path={CREATE_PROJECT} element={<CreateProject />} />
      <Route path={`${CREATE_PROJECT}/:id`} element={<CreateProject />} />
      <Route path={`${EDIT_PROJECT}/:id`} element={<CreateProject />} />
      <Route path={CREATE_PAYMENT} element={<CreatePayment />} />
      <Route path={BULK_UPLOAD} element={<BulkUpload />} />
      <Route path={INVOICES} element={<InvoicesList />} />
      <Route path={`${INVOICES}/:id`} element={<InvoiceDetails />} />
      <Route path={REPORTING} element={<ReportList />} />
      <Route path={TALENT} element={<TalentsList />} />
      <Route path={`${TALENT}/:id`} element={<TalentDetails />} />
      <Route path={PROFILE} element={<Profile />} />
      {/*TODO: Show routes for library */}
      {/*<Route path={LIBRARY} element={<Library />} />*/}
      {/*<Route path={CREATE_DOCUMENT} element={<NewSignature />} />*/}
      {isAdmin && (
        <>
          <Route path={ADMINISTRATION_COMPANIES} element={<CompaniesList />} />
          <Route
            path={ADMINISTRATION_COMPANIES_CREATE}
            element={<CreateCompany />}
          />
          <Route
            path={`${ADMINISTRATION_COMPANIES_EDIT}/:id`}
            element={<CreateCompany />}
          />
          <Route path={ADMINISTRATION_TALENT} element={<AdminTalentsList />} />
          <Route
            path={ADMINISTRATION_TALENT_CREATE}
            element={<CreateTalent />}
          />
          <Route
            path={`${ADMINISTRATION_TALENT_EDIT}/:id`}
            element={<CreateTalent />}
          />
          <Route path={ADMINISTRATION_MANAGERS} element={<ManagersList />} />
          <Route
            path={ADMINISTRATION_MANAGERS_CREATE}
            element={<CreateManager />}
          />
          <Route
            path={`${ADMINISTRATION_MANAGERS_CREATE}/:id`}
            element={<CreateManager />}
          />
          <Route
            path={`${ADMINISTRATION_MANAGERS_EDIT}/:id`}
            element={<CreateManager />}
          />
        </>
      )}
      {isCompanyManager && (
        <>
          <Route path={ADMINISTRATION_MANAGERS} element={<ManagersList />} />
          <Route
            path={`${ADMINISTRATION_MANAGERS}/:id`}
            element={<ManagerDetails />}
          />
        </>
      )}
      <Route path={'*'} element={<Navigate to={DASHBOARD} />} />
    </Routes>
  );
};

export default RouterConfig;
